import L from "leaflet";
import attachLayerHealthMonitor, {HardFailInfo} from "features/map/utils/layerHealthMonitor";
import { WMSOptions, TileLayerOptions } from "leaflet"

// WMS Layer
export const createWmsLayer = (url: string, options: WMSOptions) => {
    return L.tileLayer.wms(url, options);
}

// Monitored WMS layer
export function createMonitoredWMSLayer(url: string, options: WMSOptions, id: string, label: string, onLayerEvent: (info: HardFailInfo) => void) {
  const layer = L.tileLayer.wms(url, options);
  const docId = options.id || null; // use options.id if available, otherwise fallback to id
  const detach = attachLayerHealthMonitor(layer, docId, id, label, onLayerEvent);
  // return both so callers can detach explicitly if needed
  return { layer, detach };
}

// Tile Layer
export const createTileLayer = (url: string, options: TileLayerOptions) => {
    return L.tileLayer(url, options);
}

